<template>
  <div>
    <q-tree
      ref="organizationalChart"
      class="filter-tree"
      :data="organization"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
  export default {
    name: "QOrganizationTree",

    props: {
      organization: {require: true}
    },

    data() {
      return {
        filterText: '',
        trustList: [],
        currentTrust: {},
        defaultProps: {
          children: 'children',
          label: 'title'
        }
      }
    },
    watch: {
      filterText(val) {
        this.$refs.organizationalChart.filter(val);
      }
    },

    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      },
      handleNodeClick(data) {
        this.currentTrust = data;
      }
    }
  }
</script>

<style scoped>

</style>